<style lang="scss" scoped>
.page-vehicle-insurance-warning {
    .c-el-input {
        width: 300px;
    }
    .el-checkbox.is-bordered+.el-checkbox.is-bordered {
        margin-left: 0px;
    }
}
</style>

<template>
    <div class="page-vehicle-insurance-warning">
        <!-- 汇总统计 + 按钮筛选 -->
        <div class="toolbars">
            <div class="buttons">
                <div class="fl mrgb10">
                    <el-button class="mrgr10" type="danger" size="medium" :plain="!showAll" @click="clickTotal">
                        总预警【{{ summaryData.total }}】
                    </el-button>
                    <el-checkbox class="mrgr5" v-model="filterExpired" border size="medium" @change="onCheckboxChange">
                        已过期【{{ summaryData.expiredCount }}】
                    </el-checkbox>
                    <el-checkbox class="mrgr5" v-model="filterExpiringSoon" border size="medium" @change="onCheckboxChange">
                        即将到期【{{ summaryData.expiringSoonCount }}】
                    </el-checkbox>
                    <el-checkbox class="mrgr5" v-model="filterNoInsurance" border size="medium" @change="onCheckboxChange">
                        无保险【{{ summaryData.noInsuranceCount }}】
                    </el-checkbox>
                </div>
                <div class="fr mrgb10">
                    <el-input class="c-el-input mrgr5 mrgb5" v-model="searchText" size="medium" placeholder="请输入车辆号/中控号/车架号/保险单号" clearable></el-input>
                    <el-button class="mrgb5" type="primary" size="medium" @click="handleSearch"><i class="fa fa-search"></i> 查询</el-button>
                    <el-button class="mrgb5" type="warning" size="medium" :loading="isExporting" @click="handleExport">
                        <i class="fa fa-sign-out"></i> 导出
                    </el-button>
                </div>
            </div>
        </div>
        <div>
            <!-- 列表 -->
            <el-table :data="tableData" style="width: 100%" border size="medium">
                <el-table-column label="最后同步时间" prop="lastSyncTimeDesc" width="100"></el-table-column>
                <el-table-column label="最后订单时间" prop="lastOrderTimeDesc" width="100"></el-table-column>
                <el-table-column label="最后在线时间" prop="lastOnlineTimeDesc" width="100"></el-table-column>
                <el-table-column label="平台" prop="platform" width="80"></el-table-column>
                <el-table-column label="服务区" prop="area"></el-table-column>
                <el-table-column label="保险区域" prop="insuranceArea"></el-table-column>
                <el-table-column label="区域检查结果">
                    <template slot-scope="scope">
                        <el-tag size="medium" :type="getAreaCheckTagType(scope.row.platform, scope.row.area, scope.row.insuranceArea)">
                            {{ checkAreaMatch(scope.row.platform, scope.row.area, scope.row.insuranceArea) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="车辆类型" prop="model" width="80"></el-table-column>
                <el-table-column label="车辆号" prop="vehicleNo"></el-table-column>
                <el-table-column label="中控号" prop="controlNo" min-width="100"></el-table-column>
                <el-table-column label="车架号" prop="chassisNo" min-width="100"></el-table-column>
                <el-table-column label="保险单号" prop="insurancePolicyNumber"></el-table-column>
                <el-table-column label="保险状态" prop="statusDesc" width="100">
                    <template slot-scope="scope">
                        <!-- status: 0=无保险, 1=已过期, 2=即将到期 -->
                        <el-tag size="medium" type="danger" v-if="scope.row.status === 1">{{ scope.row.statusDesc }}</el-tag>
                        <el-tag size="medium" type="warning" v-if="scope.row.status === 2">{{ scope.row.statusDesc }}</el-tag>
                        <el-tag size="medium" type="info" v-if="scope.row.status === 0">{{ scope.row.statusDesc }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="被保人" prop="insuredName"></el-table-column>
                <el-table-column label="保险公司" prop="insuranceCompany"></el-table-column>
                <el-table-column label="保险开始时间" prop="insuranceStartDate"></el-table-column>
                <el-table-column label="保险截止时间" prop="insuranceEndDate"></el-table-column>
                <el-table-column label="扣车点">
                    <template slot-scope="scope">
                        <span class="col_danger" v-if="scope.row.isDetained">{{ scope.row.detainedPointName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleCopy(scope.row)">复制</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 前端分页 -->
            <div class="pagination-container" v-if="filteredData.length > 0">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="page" :page-sizes="appPageSizes" :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper" :total="filteredData.length">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import * as funReport from "@/api/report"
import * as funAll from "@/api/all"
import { InsuranceWarnings } from "@/mixins/commonPageExport"
import moment from "moment"

// 区域检查结果状态定义
const AREA_CHECK_RESULTS = ["匹配失败", "一致", "不一致"]

export default {
    name: "pageVehicleInsuranceWarning",
    data() {
        return {
            // 汇总数据
            summaryData: {
                total: 0,
                expiredCount: 0,
                expiringSoonCount: 0,
                noInsuranceCount: 0
            },
            // 原始数据（三个列表合并）
            allData: [],
            // 服务区城市数据（用于区域检查）
            serviceAreaCityData: [],
            // 是否显示全部（总预警按钮）
            showAll: true,
            // 三个 checkbox 绑定值
            filterExpired: false,
            filterExpiringSoon: false,
            filterNoInsurance: false,
            // 搜索关键词（车辆号/中控号/车架号/保险单号）
            searchText: "",
            // 前端分页参数
            page: 1,
            size: window.$common.appPageSize,
            // 导出中状态（防止重复点击）
            isExporting: false
        }
    },
    computed: {
        // 筛选后的全部数据
        filteredData() {
            let base = []
            // 选中总预警时显示全部
            if (this.showAll) {
                base = this.allData
            } else {
                // 根据勾选的 checkbox 过滤
                let result = []
                if (this.filterExpired) {
                    result = result.concat(this.allData.filter(item => item.status === 1))
                }
                if (this.filterExpiringSoon) {
                    result = result.concat(this.allData.filter(item => item.status === 2))
                }
                if (this.filterNoInsurance) {
                    result = result.concat(this.allData.filter(item => item.status === 0))
                }
                base = result
            }
            // 再按搜索关键词过滤
            return this.filterBySearch(base)
        },
        // 当前页展示的数据（前端分页切片）
        tableData() {
            let start = (this.page - 1) * this.size
            return this.filteredData.slice(start, start + this.size)
        }
    },
    mounted() {
        this.getDataList()
        this.loadServiceAreaCityData()
    },
    methods: {
        // 按关键词过滤数据（车辆号/中控号/车架号/保险单号 模糊匹配）
        filterBySearch(list) {
            let keyword = (this.searchText || "").trim()
            if (!keyword) {
                return list
            }
            return list.filter(item => {
                return (item.vehicleNo || "").includes(keyword) ||
                    (item.controlNo || "").includes(keyword) ||
                    (item.chassisNo || "").includes(keyword) ||
                    (item.insurancePolicyNumber || "").includes(keyword)
            })
        },
        // 加载服务区城市数据
        async loadServiceAreaCityData() {
            try {
                const response = await funAll.SearchServiceAreas({
                    platform: "",
                    isActive: null,
                    city: "",
                    cityCode: ""
                })
                this.serviceAreaCityData = response || []
            } catch (error) {
                console.error('获取服务区城市数据失败:', error)
                this.serviceAreaCityData = []
            }
        },
        // 检查区域匹配结果
        // 返回值: "匹配失败", "一致", "不一致"
        checkAreaMatch(platform, area, insuranceArea) {
            // 如果保险区域为空，返回匹配失败
            if (!insuranceArea) {
                return AREA_CHECK_RESULTS[0]
            }
            // 如果保险区域包含"中华人民共和国"，返回一致
            if (insuranceArea.includes("中华人民共和国")) {
                return AREA_CHECK_RESULTS[1]
            }
            // 如果没有服务区城市数据，返回匹配失败
            if (!this.serviceAreaCityData || this.serviceAreaCityData.length === 0) {
                return AREA_CHECK_RESULTS[0]
            }
            // 根据平台和服务区查找对应的服务区城市配置
            const matchedConfig = this.serviceAreaCityData.find(item => item.platform === platform && item.name === area)
            // 如果没有找到对应的配置，或city为空，返回匹配失败
            if (!matchedConfig || !matchedConfig.city) {
                return AREA_CHECK_RESULTS[0]
            }
            // 保险区域包含在city内，返回一致
            if (matchedConfig.city.includes(insuranceArea)) {
                return AREA_CHECK_RESULTS[1]
            }
            // 不相同则显示不一致
            return AREA_CHECK_RESULTS[2]
        },
        // 获取区域检查结果的标签类型
        getAreaCheckTagType(platform, area, insuranceArea) {
            const result = this.checkAreaMatch(platform, area, insuranceArea)
            if (result === AREA_CHECK_RESULTS[0]) {
                return "info" // 匹配失败 - 灰色
            } else if (result === AREA_CHECK_RESULTS[1]) {
                return "success" // 一致 - 绿色
            } else {
                return "danger" // 不一致 - 红色
            }
        },
        // 点击总预警按钮：清空三个 checkbox，显示全部
        clickTotal() {
            this.showAll = true
            this.filterExpired = false
            this.filterExpiringSoon = false
            this.filterNoInsurance = false
            this.page = 1
        },
        // checkbox 变更时，取消总预警；全部取消时自动回到总预警
        onCheckboxChange() {
            let hasChecked = this.filterExpired || this.filterExpiringSoon || this.filterNoInsurance
            this.showAll = !hasChecked
            this.page = 1
        },
        // 点击查询按钮：重新请求后台最新数据，回到第一页，再按当前筛选条件前端筛选显示
        handleSearch() {
            this.page = 1
            this.getDataList()
        },
        // 导出当前筛选结果
        handleExport() {
            if (this.filteredData.length <= 0) {
                this.alert("没有需要导出的数据!")
                return
            }
            this.isExporting = true
            window.$common.fullLoading()
            try {
                // 补充导出需要的字段（区域检查结果）
                let tableDatas = this.filteredData.map(item => {
                    return {
                        ...item,
                        areaCheckResult: this.checkAreaMatch(item.platform, item.area, item.insuranceArea),
                        isDetainedDesc: item.isDetained ? "是" : ""
                    }
                })
                InsuranceWarnings(`保险预警信息表(${moment().format("YYYY-MM-DD")}).xlsx`, tableDatas)
            } catch (error) {
                window.$common.closeFullLoading()
                console.log("export error", error)
                this.alert("导出失败，请重试!")
            } finally {
                this.isExporting = false
            }
        },
        // 每页条数变化时，回到第一页
        handleSizeChange(val) {
            this.size = val
            this.page = 1
        },
        // 页码变化时，切换当前页
        handleCurrentChange(val) {
            this.page = val
        },
        // 复制单条保险预警信息（按指定字段顺序用“，”拼接，末尾不加逗号）
        handleCopy(row) {
            let fields = [
                { label: "最后在线时间", value: row.lastOnlineTimeDesc || "--" },
                { label: "最后订单时间", value: row.lastOrderTimeDesc || "--" },
                { label: "平台", value: row.platform || "--" },
                { label: "服务区", value: row.area || "--" },
                { label: "车辆类型", value: row.model || "--" },
                { label: "车辆号", value: row.vehicleNo || "--" },
                { label: "设备号", value: row.controlNo || "--" },
                { label: "车架号", value: row.chassisNo || "--" },
                { label: "保险单号", value: row.insurancePolicyNumber || "--" },
                { label: "保险状态", value: row.statusDesc || "--" },
                { label: "保险区域", value: row.insuranceArea || "--" },
                { label: "被保人", value: row.insuredName || "--" },
                { label: "保险公司", value: row.insuranceCompany || "--" },
                { label: "保险开始日期", value: row.insuranceStartDate || "--" },
                { label: "保险结束日期", value: row.insuranceEndDate || "--" },
                { label: "扣车状态", value: row.isDetained ? "已扣车" : "--" },
                { label: "扣车点位", value: row.detainedPointName || "--" }
            ]
            let txt = fields.map(x => `${x.label}：${x.value}`).join("，")
            try {
                window.navigator.clipboard.writeText(txt).then(() => {
                    this.successMsg("复制成功!")
                })
            } catch (ex) {
                this.alert(txt, "手动复制", {
                    customClass: "wordbreakba"
                })
            }
        },
        // 获取保险预警列表
        getDataList() {
            window.$common.fullLoading()
            funReport.GetInsuranceWarnings().then(response => {
                window.$common.closeFullLoading()
                if (!response) {
                    this.allData = []
                    return
                }
                // 解析汇总数据
                this.summaryData = {
                    total: response.total || 0,
                    expiredCount: response.expiredCount || 0,
                    expiringSoonCount: response.expiringSoonCount || 0,
                    noInsuranceCount: response.noInsuranceCount || 0
                }
                // 合并三个列表并补充 insurance 字段
                let expiredList = this.mapInsuranceData(response.expiredList || [])
                let expiringSoonList = this.mapInsuranceData(response.expiringSoonList || [])
                let noInsuranceList = this.mapInsuranceData(response.noInsuranceList || [])
                this.allData = [...expiredList, ...expiringSoonList, ...noInsuranceList]
            })
        },
        // 处理列表数据，提取 insurance 内嵌字段
        mapInsuranceData(list) {
            return list.map(item => {
                let ins = item.insurance || {}
                return {
                    // 补充保险预警时间字段
                    lastSyncTimeDesc:  moment(item.lastSyncTime).isValid() ? moment(item.lastSyncTime).format("YYYY-MM-DD HH:mm:ss") : "",
                    lastOrderTimeDesc: moment(item.lastOrderTime).isValid() ? moment(item.lastOrderTime).format("YYYY-MM-DD HH:mm:ss") : "",
                    lastOnlineTimeDesc: moment(item.lastOnlineTime).isValid() ? moment(item.lastOnlineTime).format("YYYY-MM-DD HH:mm:ss") : "",
                    vehicleNo: item.vehicleNo,
                    controlNo: item.controlNo,
                    chassisNo: item.chassisNo,
                    area: item.area,
                    platform: item.platform,
                    model: item.model || "",
                    status: item.status,
                    statusDesc: item.statusDesc,
                    isDetained: item.isDetained,
                    detainedPointName: item.detainedPointName || "",
                    insuredName: ins.insuredName || "",
                    insuranceCompany: ins.insuranceCompany || "",
                    insuranceArea: ins.insuranceArea || "",
                    insurancePolicyNumber: ins.insurancePolicyNumber || "",
                    // 保险时间字段（视接口实际返回调整）
                    insuranceStartDate: ins.insuranceStartDate ? moment(ins.insuranceStartDate).format("YYYY-MM-DD") : "",
                    insuranceEndDate: ins.insuranceEndDate ? moment(ins.insuranceEndDate).format("YYYY-MM-DD") : ""
                }
            })
        }
    }
}
</script>
